'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.azure.securityGroup.transformer', [
])
  .factory('azureSecurityGroupTransformer', function () {

    function normalizeSecurityGroup() {
    }

    return {
      normalizeSecurityGroup: normalizeSecurityGroup,
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/azure/securityGroup/securityGroup.transformer.js